import { lazy, Suspense } from 'react'
import { UserRole } from '../enums'
import DashboardLayout from '../layouts/Dashboard'
import AuthGuard from '../components/guards/AuthGuard'
import LoadingState from '../components/LoadingState'

const AxiomaW1s = lazy(() => import('../pages/axioma/w1/AxiomaW1s'))
const AxiomaW1 = lazy(() => import('../pages/axioma/w1/AxiomaW1'))
const AxiomaW1Analytics = lazy(() => import('../pages/axioma/w1/AxiomaW1Analytics'))

export default [
  {
    path: '/axioma/w1/',
    element: (
      <AuthGuard
        roles={[
          UserRole.SUPERADMIN,
          UserRole.ADMIN,
          UserRole.USER,
          UserRole.MANUFACTURER,
          UserRole.INSTALLER,
          UserRole.GUEST
        ]}
      >
        <DashboardLayout>
          <Suspense fallback={<LoadingState align="center" />}>
            <AxiomaW1s />
          </Suspense>
        </DashboardLayout>
      </AuthGuard>
    )
  },
  {
    path: '/axioma/w1/:id',
    element: (
      <AuthGuard
        roles={[
          UserRole.SUPERADMIN,
          UserRole.ADMIN,
          UserRole.USER,
          UserRole.MANUFACTURER,
          UserRole.INSTALLER,
          UserRole.GUEST
        ]}
      >
        <DashboardLayout>
          <Suspense fallback={<LoadingState align="center" />}>
            <AxiomaW1 />
          </Suspense>
        </DashboardLayout>
      </AuthGuard>
    )
  },
  {
    path: '/axioma/w1/:id/analytics',
    element: (
      <AuthGuard
        roles={[
          UserRole.SUPERADMIN,
          UserRole.ADMIN,
          UserRole.USER,
          UserRole.MANUFACTURER,
          UserRole.INSTALLER,
          UserRole.GUEST
        ]}
      >
        <DashboardLayout>
          <Suspense fallback={<LoadingState align="center" />}>
            <AxiomaW1Analytics />
          </Suspense>
        </DashboardLayout>
      </AuthGuard>
    )
  }
]
